import styled from 'styled-components';

export const Container = styled.p`
  text-align: justify;
`;

export default Container;
